import React, { Component } from 'react';

export default class TypeSlide extends Component {

    constructor(props) {
        super(props);

        this.state = {

        }

    }

    render() {

        let iconsJsx = [];
        let optionsJsx = [];
        let activeHit = false;
        let bottomRem = (this.props.choices.length - 1) * 3 + 1;
        this.props.choices.forEach((choice) => {
            let isActive = this.props.value === choice.value;

            let iconClass = "material-icons gc-scope-icon ";

            if (isActive) {
                activeHit = true;
                iconClass += "gc-icon--active";
            } else if (!activeHit) {
                iconClass += "gc-scope-icon--left";
            } else {
                iconClass += "gc-scope-icon--right";
            }


            let optionClass = "gc-scope-button" + (isActive ? " gc-button--active" : "");

            let optionStyle = { bottom: bottomRem + "rem" };
            bottomRem -= 3;

            iconsJsx.push((
                <div className={iconClass}>{choice.icon}</div>
            ));
            optionsJsx.push((
                <div className={optionClass} style={optionStyle} onClick={this.props.onSelect.bind(null, choice.value)}>{choice.displayText}</div>
            ));
        });

        let lrPosition = this.props.position < this.props.slideNumber ? '-100vw' : this.props.position > this.props.slideNumber ? '100vw' : '0vw';
        let cardHeight = this.props.position === this.props.slideNumber ? (16 + (this.props.choices.length * 3)) : 0;
        return (
            <div className={"gc-slide"} style={{ left: lrPosition, overflow: "hidden", height: cardHeight + 'rem' }}>
                {iconsJsx}
                <div className="gc-question scope">{this.props.question}</div>
                {optionsJsx}
            </div>
        );
    }
}